import { useState, useEffect } from "react";

const formatCity = (city) =>
  city
    ? city
        .split("-")
        .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
        .join(" ")
    : null;

const formatCategory = (category) =>
  category
    ? category
        .split("-")
        .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
        .join(" ")
    : null;

const injectLocationInFAQ = (faqList, city, zip) => {
  const formattedCity = formatCity(city);
  const hasLocation = Boolean(formattedCity && zip);

  return faqList.map(({ question, answer }) => {
    let updatedAnswer = answer;

    if (hasLocation) {
      updatedAnswer = updatedAnswer
        .replace(/<IN_CITY_ZIP>/g, `in ${formattedCity}, CA ${zip}`)
        .replace(/<IN_CITY>/g, `in ${formattedCity}`);
    } else {
      updatedAnswer = updatedAnswer
        .replace(/[\s,]*<IN_CITY_ZIP>/g, "")
        .replace(/[\s,]*<IN_CITY>/g, "");
    }

    return {
      question: question
        .replace(/<IN_CITY_ZIP>/g, `in ${formattedCity}, CA ${zip}`)
        .replace(/<IN_CITY>/g, `in ${formattedCity}`)
        .replace(/[\s,]*<IN_CITY_ZIP>/g, "")
        .replace(/[\s,]*<IN_CITY>/g, ""),
      answer: updatedAnswer.trim().replace(/\s+/g, " "),
    };
  });
};

const FAQ = ({ category = "home", city = null, zip = null, faqs = null }) => {
  const [localFaqs, setLocalFaqs] = useState([]);

  useEffect(() => {
    if (faqs && faqs.length > 0) {
      // Dynamic page: use merged FAQs from props
      const locationFaqs = injectLocationInFAQ(faqs, city, zip);
      setLocalFaqs(locationFaqs);
    } else {
      // Static page: load category FAQ dynamically
      import(`../data/faq/${category}.js`)
        .then((module) => {
          const rawFaqs = module.default || [];
          const locationFaqs = injectLocationInFAQ(rawFaqs, city, zip);
          setLocalFaqs(locationFaqs);
        })
        .catch((error) => console.error("Error loading FAQ:", error));
    }
  }, [category, city, zip, faqs]);

  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  if (!localFaqs.length) return null;

  const formattedCategory = formatCategory(category);

  return (
    <div className="bg-white py-[100px] px-4">
      <div className="mx-auto max-w-[1140px]">
        <div className="text-center mb-8">
          <h2 className="text-4xl text-left tracking-[6px] uppercase text-primary font-light mb-4">
            FAQ
          </h2>
          <p className="text-xl capitalize font-light text-left text-black font-gilda">
            {category === "home"
              ? "Answers to Your Most Common Remodeling Questions."
              : `Answers to Your Most Common ${formattedCategory} Remodeling Questions.`}
          </p>
        </div>

        <div className="space-y-2">
          {localFaqs.map((faq, index) => (
            <div key={index} className="border border-black">
              <button
                aria-label="toggle FAQ"
                className={`w-full flex justify-between items-center p-2 text-left text-md bg-white hover:text-primary ${
                  openIndex === index ? "text-primary" : "text-black"
                }`}
                onClick={() => toggleFAQ(index)}
              >
                <span>{faq.question}</span>
                <span className="text-2xl text-primary">
                  {openIndex === index ? "–" : "+"}
                </span>
              </button>
              {openIndex === index && (
                <div className="p-2 bg-white text-md text-black">
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQ;
